import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { History } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const MONTHS = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const tl = (v) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(v || 0);

const RepChart = ({ name, rows, testId }) => (
  <div data-testid={testId}>
    {name && <p className="text-sm font-semibold text-gray-700 mb-2">{name}</p>}
    <div className="h-56">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={rows} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${Math.round(v / 1000)}B`} width={40} allowDecimals={false} tickCount={5} />
          <Tooltip formatter={(v) => tl(v)} itemSorter={(item) => (item.dataKey === 'commission' ? 0 : 1)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="commission" name="Kazanılan" fill="#16a34a" radius={[4, 4, 0, 0]} />
          <Bar dataKey="lost_commission" name="Kaybedilen" fill="#dc2626" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export function PrimHistoryChart({ isAdmin }) {
  const [history, setHistory] = useState(null);
  useEffect(() => {
    axios.get(`${API_BASE}/api/prim-history?token=${localStorage.getItem('token')}`).then(r => setHistory(r.data)).catch(() => setHistory([]));
  }, []);
  if (!history) return null;

  const reps = {};
  history.forEach(({ year, month, entries }) => entries.forEach(e => {
    reps[e.username] = reps[e.username] || { name: e.full_name, rows: [] };
    reps[e.username].rows.push({ label: `${MONTHS[month - 1]} ${String(year).slice(2)}`, commission: e.commission, lost_commission: e.lost_commission });
  }));
  const list = Object.entries(reps);

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 border border-gray-100" data-testid="prim-history">
      <h2 className="text-base md:text-lg font-bold text-gray-800 flex items-center gap-2 mb-1"><History className="w-5 h-5 text-blue-600" />Prim Geçmişi</h2>
      <p className="text-xs text-gray-500 mb-4">Kapatılmış aylar · Kazanılan ve hedef nedeniyle kaybedilen prim</p>
      {list.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="prim-history-empty">Henüz kapatılmış ay bulunmuyor.</p>
      ) : (
        <div className={`grid gap-6 ${isAdmin && list.length > 1 ? 'md:grid-cols-2' : ''}`}>
          {list.map(([username, r]) => <RepChart key={username} name={isAdmin ? r.name : null} rows={r.rows} testId={`prim-history-chart-${username}`} />)}
        </div>
      )}
    </div>
  );
}
